export default /*@ngInject*/ function ($http, errorsDataService) {
    var factory = {
        listReasons,
        deleteReason,
        createReason,
        updateReason,
        exportReasons,
        importReasons
    };

    return factory;

    async function listReasons() {
        try {
            return await $http.get(`${apiUrl}api/certifications/reasons`);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function deleteReason(reasonId) {
        try {
            return await $http.delete(`${apiUrl}api/certifications/reasons/${reasonId}`);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function createReason(reason) {
        try {
            return await $http.post(`${apiUrl}api/certifications/reasons`, reason);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function updateReason(reason) {
        try {
            return await $http.put(`${apiUrl}api/certifications/reasons/${reason.Id}`, reason);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function exportReasons() {
        try {
            return await $http.get(`${apiUrl}api/certifications/reasons/export`, { responseType: "blob" });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function importReasons(fd) {
        try {
            return await $http.put(`${apiUrl}api/certifications/reasons/import`, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    function showError(err) {
        errorsDataService.catch(err);
    }

    function sendError(err) {
        throw err;
    }
}